import { useState } from 'react';
import { TimelineComment } from 'views/Tasks/Timeline/types';
import CommentItem from '../CommentItem/CommentItem';
import CommentComposer from '../CommentComposer/CommentComposer';

const MAX_INDENT_DEPTH = 6;

export interface CommentThreadProps {
    thread: TimelineComment;
    depth: number;
    orgId: string;
    dealId: number;
    timelineId: number;
    currentUserCorrelationId: string | null;
}

const CommentThread = ({
    thread, depth, orgId, dealId, timelineId, currentUserCorrelationId,
}: CommentThreadProps) => {
    const [isReplying, setIsReplying] = useState(false);

    const indentReplies = depth < MAX_INDENT_DEPTH;

    return (
        <div>
            <CommentItem
                comment={thread}
                orgId={orgId}
                dealId={dealId}
                timelineId={timelineId}
                currentUserCorrelationId={currentUserCorrelationId}
                onReply={() => setIsReplying(prev => !prev)}
            />
            {isReplying && (
                <CommentComposer
                    orgId={orgId}
                    dealId={dealId}
                    timelineId={timelineId}
                    parentId={thread.id}
                    placeholder="Write a reply…"
                    onSubmitted={() => setIsReplying(false)}
                />
            )}
            {thread.replies.length > 0 && (
                <div className={indentReplies ? 'ml-4' : undefined}>
                    {thread.replies.map(reply => (
                        <CommentThread
                            key={reply.id}
                            thread={reply}
                            depth={depth + 1}
                            orgId={orgId}
                            dealId={dealId}
                            timelineId={timelineId}
                            currentUserCorrelationId={currentUserCorrelationId}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default CommentThread;
